module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-+.564f57c5.svg";